module.exports = __webpack_public_path__ + "img/styles_background_desktop@2x.2cc27a8.jpg";